import React from 'react'

export const getCollegeListForGoalsColumns = (getStudentData, getStudentCollege, ChangeStatus) => {
	return [
		{
			name: 'Id',
			selector: (row) => row.id,
			sortable: true,
			width: '10%'
		},
		{
			name: 'College',
			selector: (row) => row.collegename,
			sortable: true,
			width: '70%'
		},
		{
			name: 'Is Check',
			width: '20%',
			center: true,
			cell: (row) => (
				<div className="form-check form-switch">
					<input
						className="form-check-input"
						type="checkbox"
						checked={getStudentCollege(row.id)}
						onChange={() => ChangeStatus(getStudentData(row.id), getStudentCollege(row.id), row.id)}
					/>
				</div>
			),
			ignoreRowClick: true
		}
	]
}
